import { createApp } from 'vue';
import { createPinia } from 'pinia';
import './styles/legacy.css';
import './styles/app.css';
import App from './App.vue';
import { router } from './router';
import { useSession } from './stores/session';

// Wrapped rather than using top-level await: this keeps the bundle free of a
// module-level await, which needs a newer build target and complicates the
// browser support story for no benefit here.
async function bootstrap(): Promise<void> {
  const app = createApp(App);
  app.use(createPinia());

  // Resolve the session before the first render, so the app never flashes the
  // sign-in screen at someone who is already signed in. A failure here is not
  // fatal — App.vue renders the signed-out state.
  await useSession().load().catch(() => {});

  app.use(router);
  app.mount('#app');
}

void bootstrap();
